import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Directive, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';

const _c0 = [[["xpo-empty-state-icon"]], [["xpo-empty-state-header"]], [["xpo-empty-state-description"]], [["xpo-empty-state-actions"]]];
const _c1 = ["xpo-empty-state-icon", "xpo-empty-state-header", "xpo-empty-state-description", "xpo-empty-state-actions"];
class XpoEmptyState {
}
XpoEmptyState.ɵfac = function XpoEmptyState_Factory(t) { return new (t || XpoEmptyState)(); };
XpoEmptyState.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoEmptyState, selectors: [["xpo-empty-state"]], ngContentSelectors: _c1, decls: 8, vars: 0, consts: [[1, "xpo-EmptyState"], [1, "xpo-EmptyState-iconWrapper"], [1, "xpo-EmptyState-header"], [1, "xpo-EmptyState-description"]], template: function XpoEmptyState_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0);
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "h2", 2);
        i0.ɵɵprojection(4, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "p", 3);
        i0.ɵɵprojection(6, 2);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(7, 3);
        i0.ɵɵelementEnd();
    } }, styles: [".flex--stretch{flex:1}.xpo-EmptyState{align-items:center;display:flex;flex-direction:column;margin:32px 0}.xpo-EmptyState-iconWrapper .mat-icon{color:#4a4a4a;font-size:58px;height:auto;width:auto}.xpo-EmptyState-header{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;font-size:32px;font-weight:500}.xpo-EmptyState-description{font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;font-size:1rem;margin:0}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoEmptyState, [{
        type: Component,
        args: [{
                selector: 'xpo-empty-state',
                templateUrl: './empty-state.component.html',
                styleUrls: ['./empty-state.component.scss'],
                encapsulation: ViewEncapsulation.None,
            }]
    }], null, null); })();

class XpoEmptyStateActions {
}
XpoEmptyStateActions.ɵfac = function XpoEmptyStateActions_Factory(t) { return new (t || XpoEmptyStateActions)(); };
XpoEmptyStateActions.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoEmptyStateActions, selectors: [["xpo-empty-state-actions"]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoEmptyStateActions, [{
        type: Directive,
        args: [{
                selector: 'xpo-empty-state-actions',
            }]
    }], null, null); })();

class XpoEmptyStateDescription {
}
XpoEmptyStateDescription.ɵfac = function XpoEmptyStateDescription_Factory(t) { return new (t || XpoEmptyStateDescription)(); };
XpoEmptyStateDescription.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoEmptyStateDescription, selectors: [["xpo-empty-state-description"]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoEmptyStateDescription, [{
        type: Directive,
        args: [{
                selector: 'xpo-empty-state-description',
            }]
    }], null, null); })();

class XpoEmptyStateHeader {
}
XpoEmptyStateHeader.ɵfac = function XpoEmptyStateHeader_Factory(t) { return new (t || XpoEmptyStateHeader)(); };
XpoEmptyStateHeader.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoEmptyStateHeader, selectors: [["xpo-empty-state-header"]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoEmptyStateHeader, [{
        type: Directive,
        args: [{
                selector: 'xpo-empty-state-header',
            }]
    }], null, null); })();

class XpoEmptyStateIcon {
}
XpoEmptyStateIcon.ɵfac = function XpoEmptyStateIcon_Factory(t) { return new (t || XpoEmptyStateIcon)(); };
XpoEmptyStateIcon.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoEmptyStateIcon, selectors: [["xpo-empty-state-icon"]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoEmptyStateIcon, [{
        type: Directive,
        args: [{
                selector: 'xpo-empty-state-icon',
            }]
    }], null, null); })();

class XpoEmptyStateModule {
}
XpoEmptyStateModule.ɵfac = function XpoEmptyStateModule_Factory(t) { return new (t || XpoEmptyStateModule)(); };
XpoEmptyStateModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoEmptyStateModule });
XpoEmptyStateModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, MatIconModule, XpoButtonModule, XpoIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoEmptyStateModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, MatIconModule, XpoButtonModule, XpoIconModule],
                declarations: [XpoEmptyState, XpoEmptyStateActions, XpoEmptyStateDescription, XpoEmptyStateHeader, XpoEmptyStateIcon],
                exports: [XpoEmptyState, XpoEmptyStateActions, XpoEmptyStateDescription, XpoEmptyStateHeader, XpoEmptyStateIcon],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoEmptyStateModule, { declarations: [XpoEmptyState, XpoEmptyStateActions, XpoEmptyStateDescription, XpoEmptyStateHeader, XpoEmptyStateIcon], imports: [CommonModule, MatIconModule, XpoButtonModule, XpoIconModule], exports: [XpoEmptyState, XpoEmptyStateActions, XpoEmptyStateDescription, XpoEmptyStateHeader, XpoEmptyStateIcon] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoEmptyState, XpoEmptyStateActions, XpoEmptyStateDescription, XpoEmptyStateHeader, XpoEmptyStateIcon, XpoEmptyStateModule };
